import type { RecentExceptionsBlock } from "@/lib/dashboardApi";
import { OperatorPanel } from "@/components/admin/dashboard/OperatorPanel";
import { fmtRelative } from "@/lib/relativeTime";

export function ExceptionsList({
  data,
}: {
  data: RecentExceptionsBlock;
}): JSX.Element {
  const isOk = data.status === "ok";
  return (
    <OperatorPanel
      testId="platform-health-exceptions"
      kicker="Errors"
      title={`Recent exceptions (${data.window_hours}h)`}
      headerRight={
        !isOk ? (
          <span
            data-testid="badge-unavailable-sentry"
            className="rounded bg-surface-canvas px-2 py-0.5 text-2xs text-text-tertiary"
          >
            Sentry unavailable
          </span>
        ) : undefined
      }
    >
      {isOk && data.groups.length > 0 ? (
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-text-secondary">
              <th className="pb-1 font-medium">Title</th>
              <th className="pb-1 font-medium">Count</th>
              <th className="pb-1 font-medium">Last seen</th>
            </tr>
          </thead>
          <tbody>
            {data.groups.map((g) => (
              <tr key={g.sentry_issue_id} className="border-t border-border-default">
                <td className="py-1">
                  <a
                    href={g.deep_link}
                    target="_blank"
                    rel="noreferrer"
                    className="text-text-primary underline hover:text-accent-secondary"
                  >
                    {g.title}
                  </a>
                </td>
                <td className="py-1 font-mono tabular-nums text-text-primary">
                  {g.count}
                </td>
                <td className="py-1 text-text-secondary">
                  {fmtRelative(g.last_seen)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-sm text-text-secondary">No recent exceptions.</p>
      )}
    </OperatorPanel>
  );
}
